import React, { useState } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "./ui/card";
import minus from "../assets/icons/minus-icon.svg";
import plus from "../assets/icons/plus-icon.svg";
import { Separator } from "./ui/separator";
import { useNavigate } from "react-router-dom";

export default function InvestFaq({ faqs }) {
  const navigate = useNavigate();
  const [openIndex, setOpenIndex] = useState(-1);

  return (
    <Card className="bg-white rounded-2xl w-full shadow-sm overflow-hidden">
      <CardHeader className="px-6 pt-6 pb-4">
        <CardTitle className="text-2xl font-medium text-gray-800">
          Frequently Asked Questions
        </CardTitle>
      </CardHeader>

      <CardContent className="px-6 pb-4">
        <div className="space-y-4">
          {faqs?.map((faq, index) => {
            const isOpen = openIndex === index;
            return (
              <div
                key={index}
                className="border border-gray-200 rounded-lg px-4 py-4 bg-white"
              >
                <button
                  className="flex items-start items-center justify-between w-full text-left"
                  onClick={() => setOpenIndex(isOpen ? -1 : index)}
                >
                  <span className="text-sm font-semibold text-gray-800">
                    {faq.question}
                  </span>
                  <div className="">
                    {isOpen ? (
                      <img
                        src={minus}
                        alt=""
                        className="h-8 w-8 p-2 flex items-center justify-center border border-gray-300 rounded-full"
                      />
                    ) : (
                      <img
                        src={plus}
                        alt=""
                        className="h-8 w-8 p-2 flex items-center justify-center border border-gray-300 rounded-full"
                      />
                    )}
                  </div>
                </button>
                {isOpen && (
                  <div className="mt-2 text-sm text-gray-500">{faq.answer}</div>
                )}
              </div>
            );
          })}
        </div>
      </CardContent>

      <Separator />

      <div className="py-4 text-center text-sm text-gray-500">
        Questions?{" "}
        <a
          onClick={() => navigate("/support/whatsapp")}
          className="text-rose-600 font-bold hover:underline hover:cursor-pointer"
        >
          Contact us
        </a>
      </div>
    </Card>
  );
}
